var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10880",
    "data-name": "Group 10880",
    transform: "translate(0.41 -0.249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4231",
    "data-name": "Rectangle 4231",
    width: 54,
    height: 53,
    transform: "translate(-0.41 0.249)",
    fill: "#d9261c",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44742",
    "data-name": "Path 44742",
    d: "M22.5,30.63l13.3-7.689L22.5,15.252ZM52.132,10.562a26.5,26.5,0,0,1,.718,4.87c.179,2.05.256,3.819.256,5.357l.154,2.153A50.92,50.92,0,0,1,52.132,35.32,6,6,0,0,1,47.7,39.754a36.134,36.134,0,0,1-6.792.718c-3.332.179-6.382.256-9.2.256l-4.075.154c-10.739,0-17.428-.41-20.068-1.128A6,6,0,0,1,3.128,35.32a26.5,26.5,0,0,1-.718-4.87c-.179-2.05-.256-3.819-.256-5.357L2,22.941A50.921,50.921,0,0,1,3.128,10.562,6,6,0,0,1,7.562,6.128a36.134,36.134,0,0,1,6.792-.718c3.332-.179,6.382-.256,9.2-.256L27.63,5C38.369,5,45.058,5.41,47.7,6.128a6,6,0,0,1,4.434,4.434",
    transform: "translate(-1.018 4.713)",
    fill: "#d9261c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt-icon.7e64f56c508a56ac482362994c235fe6.svg";
export { ForwardRef as ReactComponent };